fccd-sort-by-v2 {
  // hide the top Sort by label from view, but keep it for screen readers
  hp5-select hp5-label-decorator {
    position: absolute;
    left: -99999px;
    height: 1px;
    width: 1px;
    overflow: hidden;
  }

  .inline {
    display: flex;
    align-items: center;

    hp5-heading {
      margin-right: var(--spacing-xs);
    }
    hp5-select select {
      margin-top: 0;
    }
  }
}
